<div class="routed-container items-start">
    <div class="routed-content justify-center items-center flex flex-col w-full" #routedContainer>
        <div class="typeahead-container flex flex-col w-100 p-15 lg-mt">
            <label>Search Venues</label>
            <app-typeahead class="no-flex" [clearOnItemSelect]="true" [itemTypeID]="'venue'"
                (itemSelected)="handleVenueSelect($event)"></app-typeahead>
        </div>
        <a [routerLink]="['/venues/new']" class="fab flex items-center justify-center">
            <i class="material-icons">add</i>
        </a>
    </div>
</div>
